// pickerGuard.ts
let openCount = 0;
let lastCloseAt = 0;

export function markPickerOpen() {
  openCount++;
}

export function markPickerClose() {
  openCount = Math.max(0, openCount - 1);
  lastCloseAt = Date.now();
}

export function isPickerInteractionActive(graceMs = 200) {
  return openCount > 0 || Date.now() - lastCloseAt < graceMs;
}
